import store from '../store';

export function get_default_headers () {
    let headers = {};

    if (store.getters.jwt)
        headers['Authorization'] = 'JWT ' + store.getters.jwt;

    // if (component && component.$cookies.get('csrftoken'))
    //   headers['X-CSRFToken'] = component.$cookies.get('csrftoken');

    // eslint-disable-next-line no-console
    // console.log(headers)
    return headers;
}
